var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 19C24 19.553 23.552 20 23 20H20V23C20 23.553 19.552 24 19 24C18.448 24 18 23.553 18 23V20H15C14.448 20 14 19.553 14 19C14 18.447 14.448 18 15 18H18V15C18 14.447 18.448 14 19 14C19.552 14 20 14.447 20 15V18H23C23.552 18 24 18.447 24 19ZM16 7C16.551 7 17 6.552 17 6C17 5.448 16.551 5 16 5C15.449 5 15 5.448 15 6C15 6.552 15.449 7 16 7ZM4.808 9.151L0 13.959V5C0 2.243 2.243 0 5 0H17C19.757 0 22 2.243 22 5V12H19C17.415 12 16.115 13.235 16.008 14.793L10.366 9.151C8.833 7.618 6.34 7.618 4.808 9.151ZM13 6C13 7.654 14.346 9 16 9C17.654 9 19 7.654 19 6C19 4.346 17.654 3 16 3C14.346 3 13 4.346 13 6ZM12 19C12 17.537 13.052 16.316 14.44 16.053L8.952 10.565C8.2 9.814 6.976 9.813 6.222 10.565L0 16.787V17C0 19.757 2.243 22 5 22H12V19Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/Picture.bd08d70afad4544c4606c1e63441b954.svg";
export { ForwardRef as ReactComponent };